module.exports = __webpack_public_path__ + "static/media/social-icon-x-pink.08f25a77.svg";